export default function snapToGrid(x, y) {
  x = Math.round(x / 32) * 32;
  y = Math.round(y / 32) * 32;

  return [x, y];
}


/** WEBPACK FOOTER **
 ** ./examples/02 Drag Around/Custom Drag Layer/snapToGrid.js
 **/